// @flow

import type {SearchRequest} from '../models/SearchRequest';
import SearchUrlParser from './SearchUrlParser';
import type {Options} from './SearchUrlParser';
import querystring from 'query-string';
import {multiPrimitiveParser} from '../utils';

/*
 * Query params that require special parsing and validation, the rest we will just be handled individually as primitives
 */
const SPECIAL_PARAMS = [
    'arrival',
    'departure',
    'neLat',
    'neLong',
    'swLat',
    'swLong',
    'orderBy',
    'ascending',
    'filter'
];

export default class SERPSearchUrlParser extends SearchUrlParser {
    parse(url: string, options: Options): SearchRequest {
        const path = this.stripSegment(url);
        if (!path) {
            return {};
        }

        const searchRequestModel: SearchRequest = {};
        const tokens = path.split('?');
        if (tokens.length > 1) {
            const queryParams = querystring.parse(tokens[1]);
            Object.keys(queryParams).forEach((key) => {
                const value = queryParams[key];
                if (!SPECIAL_PARAMS.includes(key)) {
                    const parsedValue = multiPrimitiveParser(value);
                    if (parsedValue !== null) {
                        searchRequestModel[key] = parsedValue;
                    }
                }
            });
            this.setFilters(searchRequestModel, queryParams);
            this.setDates(searchRequestModel, options, queryParams);
            this.setBoundingBoxParams(searchRequestModel, queryParams);
            this.setOrderBy(searchRequestModel, queryParams);
        }

        return searchRequestModel;
    }
}
